import { useQuery } from "@tanstack/react-query";
import { API_ENDPOINTS, KeyQueryApi } from "../config/apiConfig";
import apiClient from '../services/api/apiClient';

const fetchChapterDetail = async (type: string, postId: string, chapterIndex: string) => {
  try {
    const response = await apiClient.get(
      `${API_ENDPOINTS.DETAIL_EPISODE}${type}/${postId}/${chapterIndex}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching chapter detail:", error);
    return null;
  }
};

export const useChapterDetail = (type: string, postId: string, chapterIndex: string) => {


    
  const { data, isLoading, refetch } = useQuery({
    queryKey: [KeyQueryApi.GET_DETAIL_EPISODE, type, postId, chapterIndex],
    queryFn: () => fetchChapterDetail(type, postId, chapterIndex),
    enabled: !!postId && !!chapterIndex,
    staleTime: 0, // Luôn fetch lại khi queryKey thay đổi
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    refetchOnReconnect: false
  });

  return {
    chapter: data,
    isLoading,
    refetch
  };
};
